import React from 'react';
import { issueMessage } from '../../../lib/rcu/catalog/issue';
import { addMappings } from '../../../lib/rcu/link/commands/mappings';
import type { RcuSceneEntry } from '../../../lib/rcu/wire';

export interface PayloadPreviewProps {
  entries: readonly RcuSceneEntry[];
}

/**
 * The exact JSON the console would publish for these states.
 *
 * Built by the same command that sends it, so what is on screen is what leaves
 * the tablet — including the field order and the separators inside `a` and `d`.
 * The firmware's parser logs incoming JSON, so this is also the quickest way to
 * see why a mapping did not take.
 */
export const PayloadPreview: React.FC<PayloadPreviewProps> = ({ entries }) => {
  const document = addMappings(entries);
  const text = document.ok
    ? JSON.stringify(document.value, null, 2)
    : `This cannot be sent: ${issueMessage(document.issue)}`;

  return (
    <pre className="max-h-72 overflow-auto rounded-xl bg-[#1A1A1A] p-4 text-xs leading-relaxed text-[#E8E8E8]">
      {text}
    </pre>
  );
};

export default PayloadPreview;
